import React, { useEffect, useState, Fragment } from "react";
// Icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName } from '@fortawesome/fontawesome-svg-core'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
//-------------------------
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Collapse from "@material-ui/core/Collapse";
import ListSubheader from "@material-ui/core/ListSubheader";
import { useHistory } from 'react-router';
import { Link } from "react-router-dom";
import Icon from '@material-ui/core/Icon';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import {
  AppBar,
  Toolbar,
  IconButton,
  makeStyles,
  Button,
} from "@material-ui/core";

library.add(fas, far);

const useStyles = makeStyles((theme) => ({
  sidebar: {
    maxWidth: "240px",
    height: "100vh",
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
  sidebarItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "50px",
  },
  sidebarItemContent: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  IconBtn: {
    border: "1px solid",
    margin: "5px",
    padding: "20%",
  },
  listItemIcon: {
    minWidth: "48px",
    color: "#fff",

  },
  sidebarItemIcon: {
    marginRight: "6px",
  },
  sidebarItemtext: {
    width: "100%",
    color: '#757575'
  },
}));

function SidebarItem({ depthStep, depth, item }) {
  const classes = useStyles();

  const [collapsed, setCollapsed] = useState(true);
  const { label, items, sIcon, onClickPath: onClickProp, Url } = item;

  function toggleCollapse() {
    setCollapsed((prevValue) => !prevValue);
  }

  function onClick(e) {
    if (Array.isArray(items)) {
      toggleCollapse();
    }
    if (onClickProp) {
      onClickProp(e, item);
    }
  }

  let expandIcon;

  if (Array.isArray(items) && items.length) {
    expandIcon = !collapsed ? <ExpandLessIcon /> : <ExpandMoreIcon />;
  }


  return (
    <>
      {Url == null ?
        <>
          <ListItem onClick={onClick} button dense className={classes.sidebarItem}>
            <div
              style={{ paddingLeft: depth * depthStep }}
              className={classes.sidebarItemContent}
            >
              <ListItemIcon style={{ minWidth: '25px' }}>
                <FontAwesomeIcon className={classes.sidebarItemIcon} icon={['far', sIcon as IconName]} />
              </ListItemIcon>
              <div className={classes.sidebarItemtext}>{label}</div>
            </div>
            {expandIcon}
          </ListItem>
          <Collapse in={!collapsed} timeout="auto" unmountOnExit>
            {Array.isArray(items) ? (

              <List disablePadding dense>
                {items.map((subItem, index) => (
                  <Fragment key={`${subItem.name}${index}`}>
                    <SidebarItem
                      depth={depth + 1}
                      depthStep={depthStep}
                      item={subItem}
                    />
                  </Fragment>
                ))}
              </List>
            ) : null}
          </Collapse>
        </>
        :
        <>
          <Link to={Url} style={{ textDecoration: "none", color: '#757575' }}>
            <ListItem onClick={onClick} button dense className={classes.sidebarItem}>
              <div
                style={{ paddingLeft: depth * depthStep }}
                className={classes.sidebarItemContent}
              >
                <ListItemIcon style={{ minWidth: '25px' }}>
                  <FontAwesomeIcon className={classes.sidebarItemIcon} icon={['far', sIcon as IconName]} />
                </ListItemIcon>
                <div className={classes.sidebarItemtext}>{label}</div>
              </div>
              {expandIcon}
            </ListItem>
          </Link>
          <Collapse in={!collapsed} timeout="auto" unmountOnExit>
            {Array.isArray(items) ? (
              <List disablePadding dense>
                {items.map((subItem, index) => (
                  <Fragment key={`${subItem.name}${index}`}>
                    <SidebarItem
                      depth={depth + 1}
                      depthStep={depthStep}
                      item={subItem}
                    />
                  </Fragment>
                ))}
              </List>
            ) : null}
          </Collapse>
        </>
      }

    </>
  );
}

function SideBar({ items, depthStep, depth }) {

  return (
    <div className="sidebar">
      <List disablePadding dense>
        {items.map((sidebarItem, index) => (
          <Fragment key={`${sidebarItem.name}${index}`}>
            <SidebarItem
              depthStep={depthStep}
              depth={depth}
              item={sidebarItem}
            />
          </Fragment>
        ))}
      </List>
    </div>
  );
}

export default SideBar;
